import React from "react";
import { List, Box } from "@mui/material";
import useSharedTickets from "../../hooks/useSharedTickets";
import TicketListItem from "../TicketListItem";

const SharedTicketsList = ({
	status,
	showAll,
	userTickets,
	viewTags,
	viewConnections,
	userId
}) => {
	const { ticketsSharedList, shouldShowSharedTickets } = useSharedTickets(status);

	if (!shouldShowSharedTickets) {
		return null;
	}

	return (
		<Box
			sx={{
				border: theme => theme.palette.mode === 'dark'
					? '1px solid rgba(255, 255, 255, 0.08)'
					: '1px solid rgba(0, 0, 0, 0.08)',
				backgroundColor: theme => theme.palette.mode === 'dark'
					? 'rgba(255, 255, 255, 0.01)'
					: 'rgba(0, 0, 0, 0.01)',
				overflow: 'hidden',
				boxShadow: theme => theme.palette.mode === 'dark'
					? '0 1px 3px rgba(0, 0, 0, 0.3)'
					: '0 1px 3px rgba(0, 0, 0, 0.1)',
				marginBottom: '16px'
			}}
		>
			<Box
				sx={{
					padding: '10px 16px',
					borderBottom: theme => theme.palette.mode === 'dark'
						? '1px solid rgba(255, 255, 255, 0.08)'
						: '1px solid rgba(0, 0, 0, 0.08)',
					backgroundColor: theme => theme.palette.mode === 'dark'
						? 'rgba(255, 255, 255, 0.02)'
						: 'rgba(0, 0, 0, 0.02)',
					fontSize: '12px',
					fontWeight: 600,
					color: theme => theme.palette.text.secondary,
					textTransform: 'uppercase',
					letterSpacing: '0.5px'
				}}
			>
				Grupos Compartilhados
			</Box>
			<List style={{ paddingTop: 0, paddingBottom: 0 }}>
				{ticketsSharedList.map((ticket) => (
					<TicketListItem
						key={ticket.id}
						showAll={showAll || userTickets === 'all'}
						useTransfer={!(showAll || userTickets === 'all' || +userTickets !== +userId)}
						ticket={ticket}
						viewTags={viewTags}
						viewConnections={viewConnections}
						sharedGroup
					/>
				))}
			</List>
			<Box
				sx={{
					padding: '10px 16px',
					backgroundColor: theme => theme.palette.mode === 'dark'
						? 'rgba(255, 255, 255, 0.02)'
						: 'rgba(0, 0, 0, 0.02)',
					fontSize: '12px',
					fontWeight: 600,
					color: theme => theme.palette.text.secondary,
					textTransform: 'uppercase',
					letterSpacing: '0.5px'
				}}
			>
				Atendimentos
			</Box>
		</Box>
	);
};

export default React.memo(SharedTicketsList);